const TipoUsuario = {
    data: {
        EMPLEADO: {
            tiu_id: 1,
            tiu_nombre: "Empleado"
        },
        CLIENTE: {
            tiu_id: 2,
            tiu_nombre: "Cliente"
        },
        PROVEEDOR: {
            tiu_id: 3,
            tiu_nombre: "Proveedor"
        }
    },
}

export default TipoUsuario